/**
 * Container for main pageLayout (with header, sidebar, etc.)
 */
import React from 'react'
import PropTypes, { instanceOf } from 'prop-types'
import classnames from 'classnames/bind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MasterLayout } from '@adc/ui-morpheus'
import { withCookies, Cookies } from 'react-cookie'
import router from '../../router'
import styles from './master-styles.scss'

const cx = classnames.bind(styles)

const Page = ({
  match,
  location = {},
  featureFlags,
  cookies,
  permissions,
  user,
}) => {
  const displayName = `${user.first_name} ${user.last_name.charAt()}.`
  return (
    <MasterLayout
      cls={cx('master-container')}
      match={match}
      router={router}
      pathname={location.pathname}
      featureFlags={featureFlags}
      cookies={cookies}
      permissions={permissions}
      displayName={displayName}
    />
  )
}

Page.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  featureFlags: PropTypes.object,
  user: PropTypes.object,
  cookies: instanceOf(Cookies),
  permissions: PropTypes.object.isRequired,
}

const mapStateToProps = store => ({
  user: store.user,
  featureFlags: store.featureFlags,
})

export default withRouter(connect(mapStateToProps)(withCookies(Page)))
